module.exports = __webpack_public_path__ + "media/images/about/b2-8eae30cee55faeefc859293c2ebdc311.png";